import { useEffect, useState } from "react";
import { CustomDialog } from "../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { RefExcelTranslatorHeaderApi } from "../../../../../../apis/RefExcelTranslatorHeaderApi";
import { CustomDateUtils } from "../../../../../../utils/CustomDateUtils";
import CustomBlockButton from "../../../../../../components/button/CustomBlockButton";
import { SellertoolSignatureUtils } from "../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../contexts/ApiInfoContext";
import { TemporaryErpItemApi } from "../../../../../../apis/TemporaryErpItemApi";
import { CustomBackdropController } from "../../../../../../components/backdrop/default/v1";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    margin-bottom: 100px;
`;

const StyledButtons = styled.div`
    button{
        width: 100px;
        height: 40px;
        background-color: #333;
        color:#fff;
        font-weight: 600;
        border-radius: 3px;
        &.delete-button{
            background-color: var(--redColor1);
        }
    }
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin: 10px 0 0 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  max-height: 500px;
  border: 1px solid #efefef;
`

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;

  /* width: 100%;  <-- 필요한 경우 제거하거나 조정
     min-width: 800px; <-- 원한다면 유지 (너무 좁아지지 않게)
  */
`;

const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f9fa;
`

const TableHeaderCell = styled.th`
    padding: 10px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    font-size: 14px;

    &.fixed-left{
        position: sticky;
        left: 0;
        z-index: 1;
        background-color: #f8f9fa;
    }
`

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8f9fa;
  }

  &:hover {
    background-color: #e9ecef;
  }
`

const TableCell = styled.td`
  padding: 10px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;

  .deleteButton{
    background-color: var(--redColor1);
    color: #fff;
    font-weight: 600;
    border: none;
    border-radius: 3px;
    padding: 5px 10px;
    width: 40px;
    height: 30px;
    font-size: 12px;
  }

  &.fixed-left{
    position: sticky;
    left: 0;
    z-index: 1;
    background-color: #f8f9fa;
  }
`

export function ModalTemporaryErpItemsTable({
    open,
    onClose,
    temporaryErpItems,
    onReqFetchTemporaryErpItems,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [refExcelTranslatorHeaderDetailList, setRefExcelTranslatorHeaderDetailList] = useState([]);

    useEffect(() => {
        async function fetchRefExcelTranslatorHeader() {
            const fetchResult = await RefExcelTranslatorHeaderApi().searchLatest({ params: null, headers: null })
            if (fetchResult?.content) {
                setRefExcelTranslatorHeaderDetailList(fetchResult?.content?.refExcelTranslatorHeaderDetailList);
            }
        }
        fetchRefExcelTranslatorHeader();
    }, []);

    const handleDeleteOne = async (_id) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const apiResult = await TemporaryErpItemApi().deleteOne({ params: { _id }, headers: headers });
        if(apiResult?.content){
            await onReqFetchTemporaryErpItems();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleDeleteList = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const apiResult = await TemporaryErpItemApi().deleteList({ headers: headers });
        if(apiResult?.content){
            await onReqFetchTemporaryErpItems();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
                maxWidth="xl"
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>임시 주문건 목록 <span>{temporaryErpItems?.length}건</span></CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <StyledButtons>
                        <CustomBlockButton
                            type='button'
                            className='delete-button'
                            onClick={() => handleDeleteList()}
                        >전체 비우기</CustomBlockButton>
                    </StyledButtons>
                    <TableContainer>
                        <StyledTable>
                            <TableHeader>
                                <tr>
                                    <TableHeaderCell className='fixed-left'>
                                        삭제
                                    </TableHeaderCell>
                                    {refExcelTranslatorHeaderDetailList?.map((refExcelTranslatorHeaderDetail, index) => (
                                        <TableHeaderCell key={refExcelTranslatorHeaderDetail?.id}>{refExcelTranslatorHeaderDetail?.headerName}</TableHeaderCell>
                                    ))}
                                </tr>
                            </TableHeader>
                            <tbody>
                                {temporaryErpItems.map((data, rowIndex) => {
                                    return (
                                        <TableRow key={rowIndex}>
                                            <TableCell className='fixed-left'>
                                                <CustomBlockButton
                                                    type='button'
                                                    className='deleteButton'
                                                    onClick={() => handleDeleteOne(data?._id)}
                                                >삭제</CustomBlockButton>
                                            </TableCell>
                                            {refExcelTranslatorHeaderDetailList.map((refExcelTranslatorHeaderDetail, headerIndex) => {
                                                if (refExcelTranslatorHeaderDetail.fieldName === 'channelOrderDate') {
                                                    return (
                                                        <TableCell key={headerIndex}>{CustomDateUtils().dateToYYYYMMDDhhmmss(data[refExcelTranslatorHeaderDetail.fieldName])}</TableCell>
                                                    );
                                                }
                                                return (
                                                    <TableCell key={headerIndex}>{data[refExcelTranslatorHeaderDetail.fieldName]}</TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                }
                                )}
                            </tbody>
                        </StyledTable>
                    </TableContainer>
                </StyledBody>
            </CustomDialog>
        </>
    );
}